import React, { useRef, useState } from "react";
import style from "css/telehealth.module.css";
import { Link } from "react-router-dom";
import Questions from "components/app/questions";
import { openPopup } from "redux/slices/drawerPopupSlice";
import { useDispatch } from "react-redux";
import NeatPopup from "components/device/neat/neatPopup";

function TeleRounding() {
  //dispatch
  const dispatch = useDispatch();
  const cardList = [
    {
      id: 1,
      img: "img/smartspace/teleinfo2Img1.png",
      title1: "Powerful API Integration Support",
      title2: "강력한 API 연동 지원",
      txt: (
        <div>
          {" "}
          리브테크놀로지의 Be Gate(Gateway)는 손쉬운 API 연동을 통해 병원
          <br />
          정보시스템과 Zoom 및 WebEx와의 원활한 통합을 지원합니다. 이는
          <br />
          기존 시스템과의 호환성을 높이고, 추가 개발 비용을 절감합니다.
        </div>
      ),
      component: [
        { txt: "Be Gate (Gateway)", type: true, link: "" },
        { txt: "API 연동", type: false, link: "" },
        { txt: "Zoom / Webex", type: true, link: "" },
      ],
    },
    {
      id: 2,
      img: "img/smartspace/teleinfo2Img2.png",
      title1: "Comprehensive Multi-Function Platform",
      title2: "다양한 기능의 통합 플랫폼",
      txt: (
        <div>
          리브테크놀로지의 솔루션은 원격 진료, 협진, 의료 세미나 등 다양한
          기능을
          <br />
          하나의 플랫폼에 통합하여 제공합니다. 이는 의료진과 환자가 하나의
          <br />
          시스템에서 모든 진료 활동을 관리할 수 있게 하여 사용 편의성을
          극대화합니다.
        </div>
      ),
      component: [
        {
          txt: "원격 진료 | 원격 협진 | 의료 세미나",
          type: true,
          link: "",
        },
        { txt: "통합 플랫폼", type: false, link: "" },
      ],
    },
  ];
  const cardList2 = [
    {
      id: 1,
      img: "img/smartspace/teleinfo2Img3.png",
      title1: "Superior Video Conferencing Quality",
      title2: "우수한 화상회의 품질",
      txt: (
        <div>
          고성능 화상회의 장비 Neat 제품을 활용한 고해상도 화상회의 시스템은
          <br />
          끊김 없는 영상과 명확한 음성을 제공하여 원격 진료와 협진의 품질을
          <br />
          높입니다. 이는 의료진과 환자 간의 소통을 원활하게 하고, 진료의 <br />
          정확성을 향상시킵니다.
        </div>
      ),
      component: [
        { txt: "Neat 스마트 화상회의 장비", type: true, link: "" },
        { txt: "고성능 화상회의", type: true, link: "" },
      ],
    },
    {
      id: 2,
      img: "img/smartspace/teleinfo2Img4.png",
      title1: "Secure Data Management and Protection",
      title2: "안전한 데이터 관리 및 보안",
      txt: (
        <div>
          리브테크놀로지의 시스템은 강력한 보안 기능을 통해 환자 정보와 진료
          데이터를
          <br />
          안전하게 관리합니다. 모든 통신과 데이터는 암호화되어 처리되므로,
          개인정보
          <br />
          보호를 철저히 보장합니다.
        </div>
      ),
      component: [
        {
          txt: "데이터 암호화",
          type: true,
          link: "",
        },
        { txt: "개인정보 보호", type: false, link: "" },
        { txt: "강력한 보안 기능", type: false, link: "" },
      ],
    },
  ];

  const scrollContainerRef = useRef(null);

  const handleMouseDown = (e) => {
    const container = scrollContainerRef.current;
    container.isDown = true;
    container.startX = e.pageX - container.offsetLeft;
    container.scrollLeft = container.scrollLeft;
  };

  const handleMouseLeave = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseUp = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseMove = (e) => {
    const container = scrollContainerRef.current;
    if (!container.isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - container.startX) * 0.5; // 스크롤 속도 조절
    container.scrollLeft = container.scrollLeft - walk;
  };

  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      원격진료 시스템 <font>구성 환경</font>
    </div>
  );

  const Compose = [
    // {
    //   id: 1,
    //   img: "img/device/neat/swiper_frame.png",
    //   title: "원격진료&화상회진 솔루션, MediLink",
    //   txt: "MediLink는 Zoom API와 병원 종합의료정보시스템(HIS)을 연동하여 원격진료와 화상회진을 지원하는 통합 솔루션입니다. 환자와 의료진, 보호자를 연결해 효율적인 의료 환경을 제공하며, 병원환경에 맞춘 커스터마이징이 가능합니다.",
    //   onClick: () => showDrawer("begate"),
    // },
    {
      id: 2,
      img: "img/device/neat/swiper_frame.png",
      title: "neat. frame",
      txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
      onClick: () => showDrawer("frame"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };

  const BodyInfo = [
    {
      id: 1,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          <font>
            의사가 병동을 물리적으로 이동하지 않고 진료실에서 입원환자와 직접
            소통하며 회진을 수행 할 수 있는 원격 회진 시스템 입니다.
          </font>
          <font>
            의사는 진료실에 앉아 환자의 상태를 실시간으로 모니터링하고, 환자와
            진료 상담을 진행 할 수 있습니다. 이를 통해 시간과 공간의 제약을
            극복하고, 효율적인 의료 서비스를 제공 할 수 있습니다.
          </font>
        </div>
      ),
      title: (
        <p>
          <font>진료실에서 직접 </font>
          연결하는 영상 회진 시스템
        </p>
      ),
      img: "img/smartspace/roundingImg2.png",
      usecase: (
        <p>
          <font>의사</font>
          <img
            alt=""
            src={
              `${process.env.REACT_APP_CLIENT_URL}` + "img/smartspace/cross.png"
            }
          />
          <font>환자, 보호자</font>
        </p>
      ),
    },
    {
      id: 2,
      txt: (
        <div className={style.bodyInfoTxtDetail}>
          <font>
            입원환자와 의료진이 병실에서 부재중인 보호자에게 환자의 상태를
            실시간으로 전달 할 수 있도록 돕는 원격 소통 시스템입니다. 보호자의
            안심과 환자의 심리적 안정을 도모하며, 보다 효과적인 환자 관리를
            가능하게 합니다.
          </font>
        </div>
      ),
      title: (
        <p>
          <font>부재중 보호자를 위한 </font>
          실시간 환자 상태 전달 시스템
        </p>
      ),
      img: "img/smartspace/roundingImg3.png",
      usecase: (
        <p>
          <font>보호자</font>
          <img
            alt=""
            src={
              `${process.env.REACT_APP_CLIENT_URL}` + "img/smartspace/cross.png"
            }
          />
          <font>의사, 환자</font>
        </p>
      ),
    },
  ];
  const [exNum, setExNum] = useState(1);
  const exList = [
    {
      id: 1,
      title: "시간과 자원의 절약",
      txt: "의료진이 물리적으로 병동을 이동할 필요 없이, 진료실에서 직접 회진을 수행할 수 있어 시간을 크게 절약할 수 있습니다. 이는 의료진의 업무 효율성을 높이고, 더 많은 환자들 신속하게 진료할 수 있게 합니다.",
    },
    {
      id: 2,
      title: "부재중 보호자와의 실시간 소통",
      txt: "의료진이 물리적으로 병동을 이동할 필요 없이, 진료실에서 직접 회진을 수행할 수 있어 시간을 크게 절약할 수 있습니다. 이는 의료진의 업무 효율성을 높이고, 더 많은 환자들 신속하게 진료할 수 있게 합니다.",
    },
    {
      id: 3,
      title: "의료 서비스의 접근성 향상",
      txt: "의료진이 물리적으로 병동을 이동할 필요 없이, 진료실에서 직접 회진을 수행할 수 있어 시간을 크게 절약할 수 있습니다. 이는 의료진의 업무 효율성을 높이고, 더 많은 환자들 신속하게 진료할 수 있게 합니다.",
    },
    {
      id: 4,
      title: "비대면 진료로 감염 위험 감소",
      txt: "의료진이 물리적으로 병동을 이동할 필요 없이, 진료실에서 직접 회진을 수행할 수 있어 시간을 크게 절약할 수 있습니다. 이는 의료진의 업무 효율성을 높이고, 더 많은 환자들 신속하게 진료할 수 있게 합니다.",
    },
  ];

  return (
    <>
      <NeatPopup />
      <div className={style.wrapper}>
        <div className={style.healthTitle}>
          <p>Tele-Rounding System</p>
          <p>원격 회진 시스템</p>
          <p>
            원격 회진 시스템을 통해 의료진은 어디서나 환자의 상태를 실시간으로
            모니터링하고 회진을 수행 할 수 있습니다. <br />
            개인 집무실, 진료실에서 입원환자와 직접 대면하지 않고도 회진을
            진행할 수 있으며,
            <br /> 의료진과 환자가 부재중인 보호자에게 영상회의를 통해 환자의
            근황과 컨디션을 실시간으로 전달 할 수 있습니다.
          </p>
        </div>
        <div className={style.healthImg}>
          <img
            alt=""
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/roundingImg1.png"
            }
          />
        </div>
        <div className={style.commonBody}>
          <div className={style.bodyHeader}>
            <p>
              진료실에서 <font> 병실과 보호자로 이어지는</font>
            </p>
            <p>혁신적 의료 플랫폼</p>
          </div>

          <div className={style.bodyInfoWrap}>
            {BodyInfo.map((info) =>
              info.id % 2 === 1 ? (
                <div className={style.bodyInfo}>
                  <div className={style.bodyInfoImg}>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.bodyInfoTxt}>
                    <div className={style.bodyInfoTxtBody}>
                      <p>{info.id}</p>
                      {info.title}
                      {info.usecase}
                      {info.txt}
                    </div>
                  </div>
                </div>
              ) : (
                <div className={style.bodyInfo}>
                  <div className={style.bodyInfoTxt}>
                    <div className={style.bodyInfoTxtBody}>
                      <p>{info.id}</p>
                      {info.title}
                      {info.usecase}
                      {info.txt}
                    </div>
                  </div>
                  <div className={style.bodyInfoImg}>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                </div>
              )
            )}
          </div>
        </div>

        <div className={style.healthBody1}>
          <div className={style.healthContents}>
            <p className={style.healthContentsHeader}>
              <font>의료의 새로운 기준,</font>
              <font>모든 사람을 위한 원격진료</font>
            </p>
            <div className={style.mainExBody}>
              <div className={style.meritBodyImg}>
                <div className={`${style.meritBodyImgSlide}`}>
                  <img
                    alt=""
                    className={exNum === 1 ? style.sli1 : style.slioff1}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit6.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 2 ? style.sli2 : style.slioff2}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit6.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 3 ? style.sli3 : style.slioff3}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit6.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 4 ? style.sli4 : style.slioff4}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit6.png"
                    }
                  />
                  <img
                    alt=""
                    className={exNum === 5 ? style.sli5 : style.slioff5}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/telemerit6.png"
                    }
                  />
                </div>
              </div>

              <div className={style.meritClickList}>
                {exList.map((info) =>
                  info.id === exNum ? (
                    <div className={style.meritClickBtn_on + " cursor"}>
                      <div>
                        <p>
                          <font>0{info.id}</font>
                          <font>{info.title}</font>
                        </p>
                        <p>
                          <img
                            alt=""
                            src={
                              `${process.env.REACT_APP_CLIENT_URL}` +
                              "img/smartspace/telemainMinus.png"
                            }
                          />
                        </p>
                      </div>
                      <div>{info.txt}</div>
                    </div>
                  ) : (
                    <div
                      className={style.meritClickBtn_off + " cursor"}
                      onClick={() => setExNum(info.id)}
                    >
                      <div>
                        <p>
                          <font>0{info.id}</font>
                          <font> {info.title}</font>
                        </p>
                        <p>
                          {" "}
                          <img
                            alt=""
                            src={
                              `${process.env.REACT_APP_CLIENT_URL}` +
                              "img/smartspace/telemainPlus3.png"
                            }
                          />
                        </p>
                      </div>
                      <div>{info.txt}</div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className={style.healthBody2}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/teleBackgroundImg.png')",
          }}
        >
          <div className={style.healthContents2}>
            <section>
              <p>리브테크놀로지의 Telehealth </p>
              <p>원격진료 시스템</p>
            </section>
            <section>
              {cardList.map((info) => (
                <div className={style.teleinfo2Card}>
                  <div>
                    <p>
                      <img
                        alt=""
                        src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                      />
                    </p>
                    <p>
                      <font>{info.title1}</font>
                      <font>{info.title2}</font>
                    </p>
                  </div>
                  {info.txt}
                  <div>
                    {info.component.map((data) => (
                      <p>
                        <font />
                        {data.txt}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </section>
            <section>
              {cardList2.map((info) => (
                <div className={style.teleinfo2Card}>
                  <div>
                    <p>
                      <img
                        alt=""
                        src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                      />
                    </p>
                    <p>
                      <font>{info.title1}</font>
                      <font>{info.title2}</font>
                    </p>
                  </div>
                  {info.txt}
                  <div>
                    {info.component.map((data) => (
                      <p>
                        <font />
                        {data.txt}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </section>
          </div>
        </div>

        <div className={style.commonCompose}>
          <div className={style.commonCompseBody}>
            {ComposeHeader}
            <div
              className={style.commonComposeCardWrap}
              ref={scrollContainerRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              {Compose.map((info) => (
                <div className={style.commonComposeCard}>
                  <div className={style.commonComposeCardImg}>
                    <p>
                      <font>{info.id}</font> / {Compose.length}
                    </p>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.commonComposeCardTxt}>
                    <p>{info.title}</p>
                    <p>{info.txt}</p>
                  </div>
                  <div className={style.commonComposeCardMore}>
                    {/* <Link
                      to={`${process.env.REACT_APP_CLIENT_URL + info.link}`}
                    > */}
                    <div onClick={info.onClick}>
                      <font>More</font>{" "}
                      <img
                        alt=""
                        src={
                          `${process.env.REACT_APP_CLIENT_URL}` +
                          "img/smartspace/arrowRight.png"
                        }
                      />
                    </div>
                    {/* </Link> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className={style.commonComposeFooter}>
            <div
              style={{
                backgroundImage:
                  "url('" +
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/composefooterImg.png')",
              }}
            >
              <div>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/composefooterImg.png')"
                  }
                />
                <p>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/bang.png"
                    }
                  />
                </p>
                <p>
                  <font>기업 환경에 맞춰</font> 선택하여 구축 가능합니다. 상담을
                  통해 정확히 진단해 보세요.
                </p>
              </div>
            </div>
          </div>
        </div>
        <Questions />
      </div>
    </>
  );
}

export default TeleRounding;
